import { useSettingsFeatureFlag } from '../../../settings';
import { useAppConfig } from '../../main';
export const useFeatureFlag = flag => {
  const {
    productFeatureFlags
  } = useAppConfig();
  const flagValue = useSettingsFeatureFlag(flag);
  if (productFeatureFlags && productFeatureFlags[flag] !== undefined) {
    return productFeatureFlags[flag];
  }
  return flagValue;
};
export const useBooleanFeatureFlag = flagName => !!useFeatureFlag(flagName);